import React, { useEffect } from 'react'
import { Button, Card, CardHeader, Col, Container, Nav, NavItem, Row, TabContent, TabPane, NavLink } from 'reactstrap'
import CIICalculator from './CIICalculator'
import VoyageCalculator from './VoyageCalculator'
import FuelEUCalculator from './FuelEUCalculator'
import FuelEUDailyCalculator from './FuelEUDailyCalculator'
import logo from './Media/popupLogo.png';
import { Link, useLocation } from "react-router-dom";
import './App.css';
import classnames from 'classnames';

/**
 * One entry per calculator. The URL is the source of truth for which tab is
 * open: each tab is a link to its own path, so the address bar, refresh, the
 * back button and shared links all land on the right calculator.
 */
export const CALCULATOR_TABS = [
    { id: '1', path: '/cii_calculator', label: 'CII Calculator', heading: 'CII Calculator', Component: CIICalculator },
    { id: '2', path: '/voyage_calculator', label: 'Voyage Calculator', heading: 'Voyage Calculator', Component: VoyageCalculator },
    { id: '3', path: '/fueleu_calculator', label: 'FuelEU Calculator', heading: 'FuelEU Maritime Calculator', Component: FuelEUCalculator },
    { id: '4', path: '/fueleu_daily_calculator', label: 'FuelEU Daily', heading: 'FuelEU Daily Calculator', Component: FuelEUDailyCalculator },
];

/** `/` (and anything unrecognised) opens the CII calculator, as it always has. */
const tabForPath = (pathname: string) =>
    CALCULATOR_TABS.find(tab => pathname.replace(/\/+$/, '') === tab.path) ?? CALCULATOR_TABS[0];

const CIISimulator = () => {
    const { pathname } = useLocation();
    const activeTab = tabForPath(pathname);

    useEffect(() => {
        document.title = `${activeTab.heading} | EcoSail`;
    }, [activeTab]);

    return (
        <Container fluid>
            {/* One header for every width: the logo stays centred while the two
                actions sit at the edges, and the buttons shrink rather than the
                row wrapping. Previously this was two hand-written variants
                picked by screen width. */}
            <Row className='mt-4'>
                <Col>
                    <div className='site-header'>
                        <Link to="https://ecosailinfotech.com/solutions/eco-compliance-module">
                            <Button className='btn btn-primary'>Back</Button>
                        </Link>
                        <Link to="https://ecosailinfotech.com/" className='site-header__logo'>
                            <img src={logo} alt="Ecosail" height="45" />
                        </Link>
                        <Link to="https://ecosailinfotech.com/contact/">
                            <Button className='btn btn-primary'>Contact&nbsp;Us</Button>
                        </Link>
                    </div>
                    <h1 className='site-title'>{activeTab.heading}</h1>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Container fluid>
                    <Card className='halfOpacity'>
                        <CardHeader className='pb-0'>
                            <Nav tabs className='no-border'>
                                {CALCULATOR_TABS.map(tab => (
                                    <NavItem key={tab.id}>
                                        <NavLink
                                            tag={Link}
                                            to={tab.path}
                                            className={`labelGrey ${classnames({
                                                active: activeTab.id === tab.id,
                                            })}`}
                                        >
                                            <h5>{tab.label}</h5>
                                        </NavLink>
                                    </NavItem>
                                ))}
                            </Nav>
                        </CardHeader>
                        {/* Every pane stays mounted, so a half-filled form survives
                            a switch to another calculator and back. */}
                        <TabContent activeTab={activeTab.id} className="text-muted">
                            {CALCULATOR_TABS.map(({ id, Component }) => (
                                <TabPane key={id} tabId={id} className='margin-3'>
                                    <Component />
                                </TabPane>
                            ))}
                        </TabContent>
                    </Card>
                </Container>
            </Row>
        </Container >
    )
}

export default CIISimulator
